/*
 * @Description: 按钮权限接口
 * @Autor: lwq
 * @Date: 2020-09-03 09:20:16
 * @LastEditors: lwq
 * @LastEditTime: 2020-09-03 10:00:42
 * @FilePath: \mrc-base-server-view\src\service\api\btnPermission.js
 */


import http from '../httpConfig'

const table = 'mrbase_sys_function_buttons'

// 列表
export const btnPermissionList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/functions/onload-button/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
